/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CalendarConnectionOut,
  ConnectRequest,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Exchange the browser's code for a long-lived grant and record it.
 * @summary Connect Google Calendar
 */
export const connectGoogleCalendar = (
    connectRequest: ConnectRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<CalendarConnectionOut>(
      {url: `/calendar/google/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectRequest, signal
    },
      options);
    }




export const getConnectGoogleCalendarMutationKey = () => ['connectGoogleCalendar'] as const;

export const getConnectGoogleCalendarMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleCalendar>>, TError,ConnectGoogleCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof connectGoogleCalendar>>, TError,ConnectGoogleCalendarMutationVariables, TContext> => {

const mutationKey = getConnectGoogleCalendarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectGoogleCalendar>>, ConnectGoogleCalendarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectGoogleCalendar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectGoogleCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof connectGoogleCalendar>>>
    export type ConnectGoogleCalendarMutationBody = ConnectRequest
    export type ConnectGoogleCalendarMutationError = HTTPValidationError
    export type ConnectGoogleCalendarMutationVariables = {data: ConnectRequest}

    /**
 * @summary Connect Google Calendar
 */
export const useConnectGoogleCalendar = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectGoogleCalendar>>, TError,ConnectGoogleCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectGoogleCalendar>>,
        TError,
        ConnectGoogleCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getConnectGoogleCalendarMutationOptions(options));
    }
